import { getLotFieldLabel } from './get-lot-location-label';

import { AppRoute, LOT_DETAILS, MonumentationTypeShown, Rights, ROUTE_ID } from 'src/constants';
import type { ILot } from 'src/interfaces';

export const getLotDetails = (lot: ILot) => {
  return LOT_DETAILS.filter((field) => !!lot[field]).map((lotField) => {
    let field = lot[lotField];

    switch (lotField) {
      case 'rights':
        field = Rights[lot.rights];
        break;
      case 'monumentationType':
        if (lot.monumentationType !== undefined) {
          field = MonumentationTypeShown[lot.monumentationType];
        }
        break;
    }

    return { label: getLotFieldLabel(lot.type, lotField), field };
  });
};

export const getLotUrl = (lotId: string, isExternalLink?: boolean) => {
  const publicUrl = isExternalLink ? window.location.origin : '';
  return `${publicUrl}${AppRoute.LOT_PAGE.replace(ROUTE_ID, lotId)}`;
};
